import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { DeviceDetectionService } from '../../../../../shared/services/device-detection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsuarioService } from '../../../services/usuario.service';
import { ServicoService } from '../../../services/servico.service';
import { environment } from '../../../../../../environments/environment';

declare var L: any;
declare var html2canvas: any;
declare var jsPDF: any;

@Component({
  selector: 'app-servicos-invalidos',
  standalone: false,
  templateUrl: './servicos-invalidos.component.html',
  styleUrl: './servicos-invalidos.component.css'
})
export class ServicosInvalidosComponent implements OnInit {
  constructor(
    private usuarioService: UsuarioService,
    private servicoService: ServicoService,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectionService,
    private router: Router,
    private ngZone: NgZone
  ) {}
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }
  // Filtros
  filtroUsuarioId: string = '';
  filtroDataInicio: string = this.getDataSeteDiasAtrasInput();
  filtroDataFim: string = this.getDataHojeInput();
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  // UI flags and additional filters (to match servicos template)
  showFiltros: boolean = false;
  filtroStatus: string = '';
  filtroNumeroOrdem: number | null = null;
  filtroMatricula: string = '';
  filtroNomeConsumidor: string = '';
  filtroCpf: string = '';
  filtroCnpj: string = '';
  filtroCep: string = '';
  filtroLogradouro: string = '';
  filtroBairro: string = '';
  filtroCidade: string = '';
  filtroEstado: string = '';
  filtroNumero: string = '';
  filtroNumeroVistoria: string = '';

  servicos: any[] = [];
  servicosFiltrados: any[] = [];
  erro: string | null = null;

  // Referência ao Math para uso no template
  Math = Math;
  servicoDetalhes: any = null;
  mostrarModalFoto = false;
  fotoSelecionada = '';
  private photoRotations: { [key: string]: number } = {};
  rotacaoFoto = 0;
  paginaAtual = 1;
  tamanhoPagina = 50;
  totalItens = 0;
  totalPaginas = 0;

  @ViewChild('conteudoModal', { static: false }) conteudoModal!: ElementRef;
  htmlCompletoParaExportar: string = '';

  ngOnInit(): void {
    // Buscar colaboradores e popular filtro
    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = colaboradores.map((colaborador: any) => ({
          usuarioId: colaborador.usuarioId,
          nome: colaborador.nome
        }));
      },
      error: () => {
        this.erro = 'Erro ao carregar colaboradores.';
      }
    });

    const periodoSalvo = localStorage.getItem('filtroPeriodoServicosInvalidos');
    if (periodoSalvo) {
      try {
        const periodo = JSON.parse(periodoSalvo);
        if (periodo && periodo.inicio) this.filtroDataInicio = periodo.inicio;
        if (periodo && periodo.fim) this.filtroDataFim = periodo.fim;
      } catch (e) {

      }
    }

    this.aplicarFiltro();
  }

  alterarTamanhoPagina(novoTamanho: number): void {
    this.tamanhoPagina = Number(novoTamanho) || this.tamanhoPagina;
    this.paginaAtual = 1;
    this.aplicarFiltro();
  }

  // Método usado pelo template para resetar filtros e recarregar
  resetarERecarregar(): void {
    this.resetarFiltro();
    this.aplicarFiltro();
  }

  // Método para alternar filtros com detecção de mudança
  toggleFiltros(): void {
    this.showFiltros = !this.showFiltros;
    this.cdr.markForCheck();
  }

  aplicarFiltro(): void {
    this.spinner.show();
    this.erro = null;
    this.paginaAtual = 1; // Reset para primeira página
    // Fecha o painel de filtros ao aplicar
    this.showFiltros = false;

    // Persistir filtro de período no localStorage
    localStorage.setItem('filtroPeriodoServicosInvalidos', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));

    // Se filtroUsuarioId está preenchido, busca por usuário e período
    if (this.filtroUsuarioId) {
      this.servicoService.obterTodosRegistrosPorPeriodo(
        this.filtroUsuarioId,
        this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00.000Z' : undefined,
        this.filtroDataFim ? this.filtroDataFim + 'T23:59:59.999Z' : undefined,
        this.paginaAtual,
        this.tamanhoPagina,
        'Invalido'
      ).subscribe({
        next: (response) => {
          this.processarDadosServicos(response);
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: () => {
          this.erro = 'Erro ao carregar Vistoria inválidos por usuário. Tente novamente.';
          this.servicos = [];
          this.servicosFiltrados = [];
          this.spinner.hide();
        }
      });
    } else {
      // Busca todos os Vistoria inválidos
      this.servicoService.obterTodos(
        this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00.000Z' : undefined,
        this.filtroDataFim ? this.filtroDataFim + 'T23:59:59.999Z' : undefined,
        this.paginaAtual,
        this.tamanhoPagina,
        'Invalido'
      ).subscribe({
        next: (response) => {
          this.processarDadosServicos(response);
          this.atualizarInformacoesPaginacao(response);
          this.spinner.hide();
        },
        error: () => {
          this.erro = 'Erro ao carregar Vistoria inválidos. Tente novamente.';
          this.servicos = [];
          this.servicosFiltrados = [];
          this.spinner.hide();
        }
      });
    }
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
    this.filtroDataFim = this.getDataHojeInput();
    this.tamanhoPagina = 50; // Reset page size to default
    this.paginaAtual = 1; // Reset to first page
    this.servicos = [];
    this.servicosFiltrados = [];
    this.erro = null;
    // reset filtros avancados
    this.showFiltros = false;
    this.filtroStatus = '';
    this.filtroNumeroOrdem = null;
    this.filtroMatricula = '';
    this.filtroNomeConsumidor = '';
    this.filtroCpf = '';
    this.filtroCnpj = '';
    this.filtroCep = '';
    this.filtroLogradouro = '';
    this.filtroBairro = '';
    this.filtroCidade = '';
    this.filtroEstado = '';
    this.filtroNumero = '';
    this.filtroNumeroVistoria = '';
  }
  // Formata o número da OS/vistoria (tenta vários campos possíveis)
  formatNumeroOS(item: any): string {
    if (!item) return '-';
    const candidato = item.numeroOS || item.numeroOs || item.numeroOrdem || item.numero || item.ordemNumero || item.numeroOrdemFormatado || item.osNumero || item.osNumero1 || item.osNumero2 || item.osNumero3;
    if (candidato === undefined || candidato === null || candidato === '') return '-';
    const s = candidato.toString();
    // Se contém caracteres não numéricos ou já tem formatação, retorna tal qual
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }

  private processarDadosServicos(response: any): void {
    // Para dados paginados, os registros estão no array 'itens' (português)
    const items = response?.itens || response?.items || [];

    let todosRegistros: any[] = [];

    // Se a resposta contém cadastros/recadastros (estrutura por usuário)
    if (items.length > 0 && (items[0].cadastros || items[0].recadastros)) {
      items.forEach((item: any) => {
        // Junta cadastros e recadastros, ambos podem estar presentes
        const cadastros = (item.cadastros || []).filter((c: any) => c.status === 'Invalido');
        const recadastros = (item.recadastros || []).filter((r: any) => r.status === 'Invalido');
        // Marca o tipo de serviço para cada registro e faz o mapeamento dos campos
        cadastros.forEach((c: any) => {
          todosRegistros.push({
            ...c,
            tipoServico: 'cadastro',
            dataServico: c.dataHoraInicio,
            nomeConsumidor: c.nomeConsumidor || c.nome || '',
            cpfConsumidor: c.cpfConsumidor || c.cpf || '',
            cnpjConsumidor: c.cnpjConsumidor || c.cnpj || '',
            status: c.status || 'Invalido',
            endereco: c.endereco || {
              logradouro: c.logradouro || '',
              numero: c.numero || '',
              bairro: c.bairro || '',
              cidade: c.cidade || ''
            }
          });
        });
        recadastros.forEach((r: any) => {
          todosRegistros.push({
            ...r,
            tipoServico: 'recadastro',
            dataServico: r.dataHoraInicio,
            nomeConsumidor: r.nomeConsumidor || r.nome || '',
            cpfConsumidor: r.cpfConsumidor || r.cpf || '',
            cnpjConsumidor: r.cnpjConsumidor || r.cnpj || '',
            status: r.status || 'Invalido',
            endereco: r.endereco || {
              logradouro: r.logradouro || '',
              numero: r.numero || '',
              bairro: r.bairro || '',
              cidade: r.cidade || ''
            }
          });
        });
      });
    } else if (items.length > 0) {
      // Estrutura simples (sem cadastros/recadastros)
      todosRegistros = items.map((item: any) => ({
        ...item,
        tipoServico: this.determinarTipoServico(item),
        dataServico: item.dataHoraInicio,
        nomeConsumidor: item.nomeConsumidor || item.nome || '',
        cpfConsumidor: item.cpfConsumidor || item.cpf || '',
        cnpjConsumidor: item.cnpjConsumidor || item.cnpj || '',
        status: item.status || 'Invalido',
        endereco: item.endereco || {
          logradouro: item.logradouro || '',
          numero: item.numero || '',
          bairro: item.bairro || '',
          cidade: item.cidade || ''
        }
      }));
    }

    // Ordena por data (mais recente primeiro)
    this.servicos = todosRegistros.sort((a, b) => new Date(b.dataServico).getTime() - new Date(a.dataServico).getTime());
    this.servicosFiltrados = this.servicos;

    // Aplicar filtros adicionais se necessário
    this.aplicarFiltrosLocais();

  }

  private aplicarFiltrosLocais(): void {
    if (!this.servicos || this.servicos.length === 0) {
      this.servicosFiltrados = [];
      return;
    }

    const statusFiltro = (this.filtroStatus || '').toString().trim().toLowerCase();
    const numOrdemFiltro = this.filtroNumeroOrdem;
    const matriculaFiltro = (this.filtroMatricula || '').toString().trim().toLowerCase();
    const nomeFiltro = (this.filtroNomeConsumidor || '').toString().trim().toLowerCase();
    const numeroFiltro = (this.filtroNumeroVistoria || '').toString().trim().toLowerCase();

    this.servicosFiltrados = this.servicos.filter(s => {
      // status
      if (statusFiltro) {
        // Check both 'status' and 'statusOS' (and effectiveStatus) so local filtering matches server behaviour
        const sStatus = (s.status || '').toString().toLowerCase();
        const sStatusOS = (s.statusOS || s.statusOs || s.status_os || '').toString().toLowerCase();
        const eff = (this.effectiveStatus(s) || '').toString().toLowerCase();
        if (!(sStatus.includes(statusFiltro) || sStatusOS.includes(statusFiltro) || eff.includes(statusFiltro))) return false;
      }

      // numero da ordem (aceita campo numeroOrdem, numeroOrdemFormatado ou ordemNumero)
      if (numOrdemFiltro !== null && numOrdemFiltro !== undefined && numOrdemFiltro !== 0) {
        const candidatos = [s.numeroOrdem, s.numeroOrdemFormatado, s.ordemNumero, s.numero];
        const encontrado = candidatos.some((c: any) => c !== undefined && c !== null && c.toString().indexOf(numOrdemFiltro.toString()) !== -1);
        if (!encontrado) return false;
      }

      // matricula
      if (matriculaFiltro) {
        const sMat = (s.matricula || s.matriculaConsumidor || s.matriculaUsuario || '').toString().toLowerCase();
        if (!sMat.includes(matriculaFiltro)) return false;
      }

      // nome consumidor
      if (nomeFiltro) {
        const sNome = (s.nomeConsumidor || s.nome || '').toString().toLowerCase();
        if (!sNome.includes(nomeFiltro)) return false;
      }

      // numero (Nº Vistoria) - comparar com varios campos incluindo numeroOS
      if (numeroFiltro) {
        const candidatosNumero = [
          s.numeroOS, s.numeroOs, s.numeroOrdemFormatado, s.numeroOrdem, s.numero, s.ordemNumero
        ];

        const numeroFiltroSemZeros = numeroFiltro.replace(/^0+/, '');

        const encontradoNumero = candidatosNumero.some((c: any) => {
          if (c === undefined || c === null) return false;
          const cs = c.toString().toLowerCase();
          // comparar tanto com zeros quanto sem zeros à esquerda
          if (cs.includes(numeroFiltro)) return true;
          if (cs.replace(/^0+/, '').includes(numeroFiltroSemZeros)) return true;
          return false;
        });

        if (!encontradoNumero) return false;
      }

      return true;
    });
  }

  private determinarTipoServico(item: any): string {
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    return 'cadastro';
  }

  verDetalhes(registro: any): void {
    const isTV = this.deviceService.isTV();
    const ZERO_UUID = '00000000-0000-0000-0000-000000000000';
    let idParaBuscar = '';
    const isRecadastro = registro.tipoServico === 'recadastro';
    if (isRecadastro) {
      idParaBuscar = registro.recadastroId && registro.recadastroId !== ZERO_UUID 
        ? registro.recadastroId 
        : registro.id;
    } else {
      idParaBuscar = registro.cadastroId && registro.cadastroId !== ZERO_UUID 
        ? registro.cadastroId 
        : registro.id;
    }

    if (isTV) {
      if (!idParaBuscar || idParaBuscar === ZERO_UUID) {
        console.warn('[TV] Nenhum ID válido encontrado para registro:', registro);
        return;
      }
      this.spinner.show();
      const serviceCall = isRecadastro
        ? this.servicoService.obterRecadastroPorId(idParaBuscar)
        : this.servicoService.obterCadastroPorId(idParaBuscar);
      serviceCall.subscribe({
        next: (detalhes) => {
          const queryParams: any = {};
          if (detalhes?.usuarioId) {
            queryParams.usuarioId = detalhes.usuarioId;
          }
          const idJuncao = detalhes?.idJuncao || detalhes?.IdJuncao || detalhes?.idjuncao || detalhes?.idJuncaoFk;
          if (idJuncao && idJuncao !== ZERO_UUID) {
            queryParams.idJuncao = idJuncao;
            this.servicoService.obterDetalhesporIdJuncao(idJuncao).subscribe({
              next: (detalhesCompletos) => {
                const dataEvento = detalhesCompletos?.dataHoraInicio || detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (detalhesCompletos?.recadastroId || detalhes?.recadastroId) {
                  queryParams.recadastroId = detalhesCompletos?.recadastroId || detalhes?.recadastroId;
                } else if (detalhesCompletos?.cadastroId || detalhes?.cadastroId) {
                  queryParams.cadastroId = detalhesCompletos?.cadastroId || detalhes?.cadastroId;
                }
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              },
              error: (err) => {
                console.error('[TV] Erro ao buscar detalhes por idJuncao', err);
                const dataEvento = detalhes?.dataHoraInicio;
                if (dataEvento) {
                  const day = new Date(dataEvento).toISOString().split('T')[0];
                  queryParams.filtroDataInicio = `${day}T00:00:00`;
                  queryParams.filtroDataFim = `${day}T23:59:59`;
                }
                if (isRecadastro) {
                  queryParams.recadastroId = idParaBuscar;
                } else {
                  queryParams.cadastroId = idParaBuscar;
                }
                this.ngZone.run(() => {
                  this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
                    .finally(() => this.spinner.hide());
                });
              }
            });
            return;
          }
          const dataEvento = detalhes?.dataHoraInicio;
          if (dataEvento) {
            const day = new Date(dataEvento).toISOString().split('T')[0];
            queryParams.filtroDataInicio = `${day}T00:00:00`;
            queryParams.filtroDataFim = `${day}T23:59:59`;
          }
          if (isRecadastro) {
            queryParams.recadastroId = idParaBuscar;
          } else {
            queryParams.cadastroId = idParaBuscar;
          }
          this.ngZone.run(() => {
            this.router.navigate(['/admin/roteiro-colaborador'], { queryParams })
              .finally(() => this.spinner.hide());
          });
        },
        error: (err) => {
          console.error('[TV] Erro ao buscar detalhes do cadastro/recadastro', err);
          this.spinner.hide();
          alert('Erro ao carregar detalhes para navegação.');
        }
      });
      return;
    }
    // Caso NÃO seja TV, mantém comportamento normal (abrir modal)
    this.spinner.show();
    this.servicoDetalhes = null;
    const serviceCall = isRecadastro
      ? this.servicoService.obterRecadastroPorId(registro.recadastroId || registro.id)
      : this.servicoService.obterCadastroPorId(registro.cadastroId || registro.id);
    serviceCall.subscribe({
      next: (detalhes) => {
        // Garante que tipoServico e dataRecadastramento estejam presentes
        if (isRecadastro) {
          this.servicoDetalhes = {
            ...detalhes,
            tipoServico: 'recadastro',
            dataRecadastramento: detalhes.dataRecadastramento || detalhes.dataServico || detalhes.dataHoraInicio
          };
        } else {
          this.servicoDetalhes = {
            ...detalhes,
            tipoServico: 'cadastro'
          };
        }
        this.spinner.hide();
        setTimeout(() => {
          this.inicializarMapaServico();
        }, 100);
      },
      error: () => {
        this.erro = 'Erro ao carregar detalhes da vistoria.';
        this.spinner.hide();
      }
    });
  }

  inicializarMapaServico(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapServico) {
      (window as any)._mapServico.remove();
      (window as any)._mapServico = null;
    }

    const latInicio = this.servicoDetalhes?.latitudeInicio;
    const lngInicio = this.servicoDetalhes?.longitudeInicio;
    const latFim = this.servicoDetalhes?.latitudeFim;
    const lngFim = this.servicoDetalhes?.longitudeFim;
    const divMapa = document.getElementById('map-cadastro');
    if (!divMapa) return;

    divMapa.innerHTML = '';
    divMapa.style.height = '220px';
    divMapa.style.width = '100%';

    if (latInicio && lngInicio || latFim && lngFim) {
      // Centraliza entre os pontos se ambos existem
      let centerLat = latInicio || latFim;
      let centerLng = lngInicio || lngFim;
      if (latInicio && lngInicio && latFim && lngFim) {
        centerLat = (Number(latInicio) + Number(latFim)) / 2;
        centerLng = (Number(lngInicio) + Number(lngFim)) / 2;
      }
      const map = L.map('map-cadastro').setView([centerLat, centerLng], 16);
      (window as any)._mapServico = map;

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // Marcador início (azul)
      if (latInicio && lngInicio) {
        const inicioIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latInicio, lngInicio], { icon: inicioIcon }).addTo(map).bindPopup('Início da Vistoria');
      }

      // Marcador fim (vermelho)
      if (latFim && lngFim) {
        const fimIcon = L.icon({
          iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
          iconSize: [48, 48],
          iconAnchor: [24, 48],
          popupAnchor: [0, -45]
        });
        L.marker([latFim, lngFim], { icon: fimIcon }).addTo(map).bindPopup('Fim da Vistoria');
      }
    } else {
      divMapa.innerHTML = '<div class="d-flex align-items-center justify-content-center h-100 text-muted"><i class="bi bi-geo-alt-slash me-2"></i>Coordenadas não disponíveis</div>';
    }
  }

  fecharModalDetalhes(): void {
    // Remove mapa anterior se existir
    if ((window as any)._mapServico) {
      (window as any)._mapServico.remove();
      (window as any)._mapServico = null;
    }

    this.servicoDetalhes = null;
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = url || '';
    // Load saved rotation for this photo (if any)
    this.rotacaoFoto = this.getPhotoRotation(url);
    this.mostrarModalFoto = true;
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
    this.rotacaoFoto = 0;
  }

  /** Rotate a photo by delta degrees (e.g. 90 or -90). Uses URL as key. */
  rotatePhoto(url: string | undefined, delta: number): void {
    if (!url) return;
    const key = this.getFotoRotacaoKey(url);
    const current = this.photoRotations[key] ?? this.loadRotationFromStorage(key) ?? 0;
    // normalize delta to multiples of 90
    const normalized = Math.round(delta / 90) * 90;
    let next = (current + normalized) % 360;
    if (next < 0) next += 360;
    this.photoRotations[key] = next;
    this.saveRotationToStorage(key, next);
    // if modal is showing this photo, update rotacaoFoto
    if (this.mostrarModalFoto && this.fotoSelecionada === url) this.rotacaoFoto = next;
  }

  /** Returns current rotation for an image URL (degrees) */
  getPhotoRotation(url: string | undefined): number {
    if (!url) return 0;
    const key = this.getFotoRotacaoKey(url);
    return this.photoRotations[key] ?? this.loadRotationFromStorage(key) ?? 0;
  }

  getFotoRotacaoKey(url: string): string {
    const prefix = 'invalido_foto_rotacao:';
    if (!url) return prefix + url;
    // Normalize to full URL so saved keys match regardless of whether callers pass a relative or full URL
    const full = this.getFullImageUrl(url);
    return prefix + full;
  }

  private saveRotationToStorage(key: string, value: number): void {
    try { localStorage.setItem(key, String(value)); } catch (e) { }
  }

  private loadRotationFromStorage(key: string): number | null {
    try {
      const v = localStorage.getItem(key);
      return v !== null ? Number(v) : null;
    } catch (e) { return null; }
  }

  exportarServicoParaPDF(): void {
    if (!this.servicoDetalhes) return;

    const dadosServico = { ...this.servicoDetalhes };
    const modalBodyOriginal = document.querySelector('.modal-body') as HTMLElement;
    if (!modalBodyOriginal) return;

    const modalBodyClone = modalBodyOriginal.cloneNode(true) as HTMLElement;

    modalBodyClone.style.position = 'absolute';
    modalBodyClone.style.top = '-9999px';
    modalBodyClone.style.left = '-9999px';
    modalBodyClone.style.overflow = 'visible';
    modalBodyClone.style.maxHeight = 'none';
    modalBodyClone.style.height = 'auto';
    modalBodyClone.style.width = modalBodyOriginal.offsetWidth + 'px';
    modalBodyClone.style.visibility = 'visible';
    modalBodyClone.style.pointerEvents = 'none';
    modalBodyClone.style.opacity = '1';

    document.body.appendChild(modalBodyClone);
    this.fecharModalDetalhes();

    setTimeout(() => {
      html2canvas(modalBodyClone, {
        useCORS: true,
        allowTaint: true,
        scale: 2,
        logging: false,
        height: modalBodyClone.scrollHeight,
        width: modalBodyClone.scrollWidth
      }).then((canvas: any) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        const nomeConsumidor = dadosServico.nomeConsumidor || 'Sem_Nome';
        const dataServico = dadosServico.dataServico ?
          new Date(dadosServico.dataServico).toLocaleDateString('pt-BR').replace(/\//g, '-') :
          new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');

        const nomeArquivo = `Servico_Invalido_${nomeConsumidor}_${dataServico}.pdf`;
        pdf.save(nomeArquivo);

        document.body.removeChild(modalBodyClone);
      }).catch(() => {
        document.body.removeChild(modalBodyClone);
      });
    }, 500);
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    // Use inclusive last 7 days: today and the 6 previous days -> subtract 7 to get start date 7 days ago
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }
  onFiltroDataFimChange(): void {
    // If no end date selected, do nothing (user may be clearing the filter)
    if (!this.filtroDataFim) {
      return;
    }

    // Persistir filtro de período no localStorage ao alterar data fim
    localStorage.setItem('filtroPeriodoServicosInvalidos', JSON.stringify({
      inicio: this.filtroDataInicio,
      fim: this.filtroDataFim
    }));

    // Allow the ngModel binding to settle, then apply the filter.
    setTimeout(() => {
      try {
        this.aplicarFiltro();
      } catch (e) {
        // swallow to avoid breaking UI; spinner/error handling is inside aplicarFiltro
        console.error('Erro ao aplicar filtro automaticamente por data fim', e);
      }
    }, 50);
  }
  maskCpf(cpf: string): string {
    if (!cpf) return '';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }

  getTipoServico(registro: any): string {
    return this.determinarTipoServico(registro);
  }

  getEnderecoCompleto(servico: any): string {
    if (servico.endereco) {
      const { logradouro, numero, bairro, cidade } = servico.endereco;
      return `${logradouro || ''} ${numero || ''}, ${bairro || ''}, ${cidade || ''}`.trim();
    }

    if (servico.logradouro) {
      return `${servico.logradouro || ''} ${servico.numero || ''}, ${servico.bairro || ''}, ${servico.cidade || ''}`.trim();
    }

    return '-';
  }

  private atualizarInformacoesPaginacao(response: any): void {
    if (response.totalItens !== undefined) {
      this.totalItens = response.totalItens;
      this.totalPaginas = Math.ceil(this.totalItens / this.tamanhoPagina);
    } else {
      this.totalItens = this.servicosFiltrados.length;
      this.totalPaginas = 1;
    }
  }

  proximaPagina(): void {
    if (this.paginaAtual < this.totalPaginas) {
      this.paginaAtual++;
      this.carregarPagina();
    }
  }

  paginaAnterior(): void {
    if (this.paginaAtual > 1) {
      this.paginaAtual--;
      this.carregarPagina();
    }
  }

  irParaPagina(pagina: number): void {
    if (pagina >= 1 && pagina <= this.totalPaginas && pagina !== this.paginaAtual) {
      this.paginaAtual = pagina;
      this.carregarPagina();
    }
  }

  private carregarPagina(): void {
    this.spinner.show();

    // Se filtroUsuarioId está preenchido, busca por usuário e período
    if (this.filtroUsuarioId) {
      this.servicoService.obterTodosRegistrosPorPeriodo(
        this.filtroUsuarioId,
        this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00.000Z' : undefined,
        this.filtroDataFim ? this.filtroDataFim + 'T23:59:59.999Z' : undefined,
        this.paginaAtual,
        this.tamanhoPagina,
        'Invalido'
      ).subscribe({
        next: (response) => {
          this.processarDadosPaginados(response);
          this.spinner.hide();
        },
        error: () => {
          this.erro = 'Erro ao carregar página.';
          this.spinner.hide();
        }
      });
    } else {
      // Busca todos os Vistoria inválidos
      this.servicoService.obterTodos(
        this.filtroDataInicio ? this.filtroDataInicio + 'T00:00:00.000Z' : undefined,
        this.filtroDataFim ? this.filtroDataFim + 'T23:59:59.999Z' : undefined,
        this.paginaAtual,
        this.tamanhoPagina,
        'Invalido'
      ).subscribe({
        next: (response) => {
          this.processarDadosPaginados(response);
          this.spinner.hide();
        },
        error: () => {
          this.erro = 'Erro ao carregar página.';
          this.spinner.hide();
        }
      });
    }
  }

  private processarDadosPaginados(response: any): void {
    const items = response?.itens || response?.items || [];

    // ⭐ Os registros já vem filtrados com status Invalido do backend
    const registrosInvalidos = items.map((item: any) => ({
      ...item,
      tipoServico: this.determinarTipoServico(item),
      dataServico: item.dataHoraInicio
    }));

    this.servicos = registrosInvalidos;
    this.servicosFiltrados = registrosInvalidos;
    this.aplicarFiltrosLocais();
  }

  obterPaginas(): number[] {
    const paginas: number[] = [];
    const maxPaginas = 5;
    const metade = Math.floor(maxPaginas / 2);

    let inicio = Math.max(1, this.paginaAtual - metade);
    let fim = Math.min(this.totalPaginas, inicio + maxPaginas - 1);

    if (fim - inicio < maxPaginas - 1) {
      inicio = Math.max(1, fim - maxPaginas + 1);
    }

    for (let i = inicio; i <= fim; i++) {
      paginas.push(i);
    }

    return paginas;
  }

  effectiveStatus(servico: any): string {
    if (!servico) return '';
    const statusRaw = (servico.status || '').toString();
    const status = statusRaw.toLowerCase();
    const statusOS = (servico.statusOS || servico.statusOs || servico.status_os || '').toString();

    // Se status indica um dos casos em que devemos priorizar o próprio status:
    if (['analisando', 'validado', 'invalido'].includes(status)) {
      return statusRaw;
    }

    if (statusOS) return statusOS;

    return statusRaw || '';
  }
}
